'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Reflect$construct = require('@babel/runtime-corejs3/core-js-stable/reflect/construct');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _possibleConstructorReturn = require('@babel/runtime-corejs3/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime-corejs3/helpers/getPrototypeOf');
var _inherits = require('@babel/runtime-corejs3/helpers/inherits');
var _toConsumableArray = require('@babel/runtime-corejs3/helpers/toConsumableArray');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _Object$values = require('@babel/runtime-corejs3/core-js-stable/object/values');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
require('../data/index.js');
var expressionValidator = require('./expression-validator.js');
var operators_enum = require('./operators.enum.js');
var dataType_enum = require('../data/data-type.enum.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Reflect$construct__default = /*#__PURE__*/_interopDefaultLegacy(_Reflect$construct);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _Object$values__default = /*#__PURE__*/_interopDefaultLegacy(_Object$values);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);

function _callSuper(t, o, e) { return o = _getPrototypeOf__default["default"](o), _possibleConstructorReturn__default["default"](t, _isNativeReflectConstruct() ? _Reflect$construct__default["default"](o, e || [], _getPrototypeOf__default["default"](t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct__default["default"](Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

/**
 * JSON format for condition.
 *
 * @export
 * @interface ConditionJson
 */

/**
 * Base class for condition.
 *
 * @export
 * @abstract
 * @class BaseCondition
 */
var BaseCondition = /*#__PURE__*/function () {
  function BaseCondition(operands, operator) {
    _classCallCheck__default["default"](this, BaseCondition);
    this.operands = operands;
    this.operator = operator;
  }
  return _createClass__default["default"](BaseCondition, [{
    key: "getType",
    value: function getType() {
      return dataType_enum.DataType.Bool;
    }
  }, {
    key: "getReferredVertexOrEdgeTypes",
    value: function getReferredVertexOrEdgeTypes() {
      var types = [];
      if (this.operands) {
        var _context;
        _forEachInstanceProperty__default["default"](_context = this.operands).call(_context, function (operand) {
          return types.push.apply(types, _toConsumableArray__default["default"](operand.getReferredVertexOrEdgeTypes()));
        });
      }
      return types;
    }
  }, {
    key: "evaluate",
    value: function evaluate() {
      return {
        applicable: false
      };
    }
  }]);
}();

/**
 * Class for handling undefined condition.
 *
 * @export
 * @class NullCondition
 * @extends {BaseCondition}
 */
var NullCondition = /*#__PURE__*/function (_BaseCondition) {
  function NullCondition() {
    _classCallCheck__default["default"](this, NullCondition);
    return _callSuper(this, NullCondition, [undefined, undefined]);
  }
  _inherits__default["default"](NullCondition, _BaseCondition);
  return _createClass__default["default"](NullCondition, [{
    key: "getType",
    value: function getType() {
      return dataType_enum.DataType.Unknown;
    }
  }, {
    key: "toString",
    value: function toString() {
      return '';
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'NullCondition',
        operands: []
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      return {
        success: false,
        errors: ['Please choose condition type.']
      };
    }
  }]);
}(BaseCondition);

/**
 * Class for comparison condition.
 * String and numeric comparison are supported.
 *
 * @export
 * @class ComparisonCondition
 * @extends {BaseCondition}
 */
var ComparisonCondition = /*#__PURE__*/function (_BaseCondition2) {
  function ComparisonCondition(operands, operator) {
    var _this;
    _classCallCheck__default["default"](this, ComparisonCondition);
    _this = _callSuper(this, ComparisonCondition, [operands, operator]);
    _defineProperty__default["default"](_this, "operandsTypes", [['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', 'BoolConstant', 'DatetimeConstant', 'IntParam', 'RealParam', 'BoolParam', 'StringParam', 'DatetimeParam', 'IntAccum', 'RealAccum', 'StringAccum', 'BoolAccum', 'LoadingVariable', 'AliasReference', 'AttrVariable', 'AttrVariableWithAlias', 'Function', operators_enum.ArithmeticOperator.Plus, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Power], ['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', 'BoolConstant', 'DatetimeConstant', 'IntParam', 'RealParam', 'BoolParam', 'DatetimeParam', 'StringParam', 'IntAccum', 'RealAccum', 'StringAccum', 'BoolAccum', 'LoadingVariable', 'AliasReference', 'AttrVariable', 'AttrVariableWithAlias', 'Function', operators_enum.ArithmeticOperator.Plus, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Power]]);
    return _this;
  }
  _inherits__default["default"](ComparisonCondition, _BaseCondition2);
  return _createClass__default["default"](ComparisonCondition, [{
    key: "toString",
    value: function toString() {
      var _context2, _context3;
      return _concatInstanceProperty__default["default"](_context2 = _concatInstanceProperty__default["default"](_context3 = "(".concat(this.operands[0], " ")).call(_context3, this.operator, " ")).call(_context2, this.operands[1], ")");
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'ComparisonCondition',
        operator: this.operator,
        operands: [this.operands[0].toJson(), this.operands[1].toJson()]
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var _context4;
      if (!_includesInstanceProperty__default["default"](_context4 = _Object$values__default["default"](operators_enum.RelationalOperator)).call(_context4, this.operator)) {
        return {
          success: false,
          errors: ['This expression contains an unsupported condition type. ' + 'Did you import a solution from a higher version of GraphStudio?']
        };
      }
      if (!this.operands[0].semanticCheck().success || !this.operands[1].semanticCheck().success) {
        return {
          success: false,
          errors: []
        };
      }
      var passSemanticCheck = true;
      var semanticErrors = [];
      var leftOperandType = this.operands[0].getType();
      var rightOperandType = this.operands[1].getType();
      if (expressionValidator.ExpressionValidator.isBoolean(rightOperandType) && expressionValidator.ExpressionValidator.isBoolean(leftOperandType)) {
        // The operators between two boolean operands should be '==' or '!='.
        if (this.operator !== '==' && this.operator !== '!=') {
          passSemanticCheck = false;
          semanticErrors.push("Cannot compare ".concat(leftOperandType.toString(), " ") + "expressions with ".concat(this.operator, " operator."));
        }
      }
      if (leftOperandType !== rightOperandType && !(expressionValidator.ExpressionValidator.isNumeric(leftOperandType) && expressionValidator.ExpressionValidator.isNumeric(rightOperandType))) {
        // Integer type is compatible with real type.
        passSemanticCheck = false;
        semanticErrors.push("Cannot compare ".concat(leftOperandType.toString(), " ") + "and ".concat(rightOperandType.toString(), "."));
      }
      if (expressionValidator.ExpressionValidator.isVertexOrEdge(leftOperandType) && expressionValidator.ExpressionValidator.isVertexOrEdge(rightOperandType)) {
        // The operators between two boolean operands should be '==' or '!='.
        if (this.operator !== '==' && this.operator !== '!=') {
          passSemanticCheck = false;
          semanticErrors.push("Cannot compare ".concat(leftOperandType.toString(), " ") + "expressions with ".concat(this.operator, " operator."));
        }
      }
      return {
        success: passSemanticCheck,
        errors: semanticErrors
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(nodeOrLink) {
      var leftOperandEvalResult = this.operands[0].evaluate(nodeOrLink);
      var rightOperandEvalResult = this.operands[1].evaluate(nodeOrLink);
      if (!leftOperandEvalResult.applicable || !rightOperandEvalResult.applicable) {
        return {
          applicable: false
        };
      }
      var evalResult;
      switch (this.operator) {
        case '==':
          {
            evalResult = leftOperandEvalResult.value === rightOperandEvalResult.value;
            break;
          }
        case '!=':
          {
            evalResult = leftOperandEvalResult.value !== rightOperandEvalResult.value;
            break;
          }
        case '>':
          {
            evalResult = leftOperandEvalResult.value > rightOperandEvalResult.value;
            break;
          }
        case '>=':
          {
            evalResult = leftOperandEvalResult.value >= rightOperandEvalResult.value;
            break;
          }
        case '<':
          {
            evalResult = leftOperandEvalResult.value < rightOperandEvalResult.value;
            break;
          }
        case '<=':
          {
            evalResult = leftOperandEvalResult.value <= rightOperandEvalResult.value;
            break;
          }
      }
      return {
        applicable: true,
        value: evalResult
      };
    }
  }]);
}(BaseCondition);

/**
 * Class for IS NUMERIC or IS EMPTY condition.
 *
 * @export
 * @class IsCondition
 * @extends {BaseCondition}
 */
var IsCondition = /*#__PURE__*/function (_BaseCondition3) {
  function IsCondition(operands, operator) {
    var _this2;
    _classCallCheck__default["default"](this, IsCondition);
    _this2 = _callSuper(this, IsCondition, [operands, operator]);
    _defineProperty__default["default"](_this2, "operandsTypes", [['NullExpression', 'LoadingVariable', 'Function']]);
    return _this2;
  }
  _inherits__default["default"](IsCondition, _BaseCondition3);
  return _createClass__default["default"](IsCondition, [{
    key: "toString",
    value: function toString() {
      var _context5;
      return _concatInstanceProperty__default["default"](_context5 = "(".concat(this.operands[0], " ")).call(_context5, this.operator, ")");
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'IsCondition',
        operator: this.operator,
        operands: [this.operands[0].toJson()]
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      // If semantic checks for the children nodes fail return false as well for this level.
      if (!this.operands[0].semanticCheck().success) {
        return {
          success: false,
          errors: []
        };
      }
      var passSemanticCheck = true;
      var semanticErrors = [];
      if (!expressionValidator.ExpressionValidator.isString(this.operands[0].getType())) {
        passSemanticCheck = false;
        semanticErrors.push('Only string type expression is allowed here.');
      }
      return {
        success: passSemanticCheck,
        errors: semanticErrors
      };
    }
  }]);
}(BaseCondition);

/**
 * Class for IN condition.
 *
 * @export
 * @class InCondition
 * @extends {BaseCondition}
 */
var InCondition = /*#__PURE__*/function (_BaseCondition4) {
  function InCondition(operands) {
    var _this3;
    _classCallCheck__default["default"](this, InCondition);
    _this3 = _callSuper(this, InCondition, [operands, operators_enum.PredicateOperator.In]);
    _defineProperty__default["default"](_this3, "operandsTypes", [['NullExpression', 'LoadingVariable', 'Function'], ['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', operators_enum.ArithmeticOperator.Plus, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Power]]);
    return _this3;
  }
  _inherits__default["default"](InCondition, _BaseCondition4);
  return _createClass__default["default"](InCondition, [{
    key: "toString",
    value: function toString() {
      var _context6, _context7;
      return "(".concat(this.operands[0], " IN (") + _mapInstanceProperty__default["default"](_context6 = _sliceInstanceProperty__default["default"](_context7 = this.operands).call(_context7, 1)).call(_context6, function (operand) {
        return operand.toString();
      }).join(', ') + "))";
    }
  }, {
    key: "toJson",
    value: function toJson() {
      var _context8;
      return {
        type: 'InCondition',
        operands: _mapInstanceProperty__default["default"](_context8 = this.operands).call(_context8, function (operand) {
          return operand.toJson();
        })
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      // If semantic checks for the children nodes fail return false as well for this level.
      for (var i = 0; i < this.operands.length; i++) {
        if (!this.operands[i].semanticCheck().success) {
          return {
            success: false,
            errors: []
          };
        }
      }
      var passSemanticCheck = true;
      var semanticErrors = [];
      var baseType = this.operands[0].getType();
      if (expressionValidator.ExpressionValidator.isNumeric(baseType)) {
        var _context9, _context10;
        _forEachInstanceProperty__default["default"](_context9 = _sliceInstanceProperty__default["default"](_context10 = this.operands).call(_context10, 1)).call(_context9, function (operand, i) {
          if (!expressionValidator.ExpressionValidator.isNumeric(operand.getType())) {
            var _context11;
            passSemanticCheck = false;
            semanticErrors.push(_concatInstanceProperty__default["default"](_context11 = "Expression".concat(i + 1, " should be Numeric, not ")).call(_context11, operand.getType(), "."));
          }
        });
      } else if (expressionValidator.ExpressionValidator.isString(baseType)) {
        var _context12, _context13;
        _forEachInstanceProperty__default["default"](_context12 = _sliceInstanceProperty__default["default"](_context13 = this.operands).call(_context13, 1)).call(_context12, function (operand, i) {
          if (!expressionValidator.ExpressionValidator.isString(operand.getType())) {
            var _context14;
            passSemanticCheck = false;
            semanticErrors.push(_concatInstanceProperty__default["default"](_context14 = "Expression".concat(i + 1, " should be String, not ")).call(_context14, operand.getType(), "."));
          }
        });
      } else {
        passSemanticCheck = false;
        semanticErrors.push("Expression cannot be ".concat(baseType.toString(), "."));
      }
      return {
        success: passSemanticCheck,
        errors: semanticErrors
      };
    }
  }]);
}(BaseCondition);

/**
 * Class for BETWEEN AND condition.
 *
 * @export
 * @class BetweenAndCondition
 * @extends {BaseCondition}
 */
var BetweenAndCondition = /*#__PURE__*/function (_BaseCondition5) {
  function BetweenAndCondition(operands) {
    var _this4;
    _classCallCheck__default["default"](this, BetweenAndCondition);
    _this4 = _callSuper(this, BetweenAndCondition, [operands, operators_enum.PredicateOperator.BetweenAnd]);
    _defineProperty__default["default"](_this4, "operandsTypes", [['NullExpression', 'LoadingVariable', 'Function'], ['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', operators_enum.ArithmeticOperator.Plus, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Power], ['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', operators_enum.ArithmeticOperator.Plus, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Power]]);
    return _this4;
  }
  _inherits__default["default"](BetweenAndCondition, _BaseCondition5);
  return _createClass__default["default"](BetweenAndCondition, [{
    key: "toString",
    value: function toString() {
      var _context15, _context16;
      return _concatInstanceProperty__default["default"](_context15 = _concatInstanceProperty__default["default"](_context16 = "(".concat(this.operands[0], " BETWEEN ")).call(_context16, this.operands[1], " AND ")).call(_context15, this.operands[2], ")");
    }
  }, {
    key: "toJson",
    value: function toJson() {
      var _context17;
      return {
        type: 'BetweenAndCondition',
        operands: _mapInstanceProperty__default["default"](_context17 = this.operands).call(_context17, function (operand) {
          return operand.toJson();
        })
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      for (var i = 0; i < this.operands.length; i++) {
        if (!this.operands[i].semanticCheck().success) {
          // If semantic checks for the children nodes fail return false as well for this level.
          return {
            success: false,
            errors: []
          };
        }
      }
      var passSemanticCheck = true;
      var semanticErrors = [];
      var baseType = this.operands[0].getType();
      if (expressionValidator.ExpressionValidator.isNumeric(baseType)) {
        var _context18, _context19;
        _forEachInstanceProperty__default["default"](_context18 = _sliceInstanceProperty__default["default"](_context19 = this.operands).call(_context19, 1)).call(_context18, function (operand, i) {
          if (!expressionValidator.ExpressionValidator.isNumeric(operand.getType())) {
            var _context20;
            passSemanticCheck = false;
            semanticErrors.push(_concatInstanceProperty__default["default"](_context20 = "Expression".concat(i + 1, " should be Numeric, not ")).call(_context20, operand.getType(), "."));
          }
        });
      } else if (expressionValidator.ExpressionValidator.isString(baseType)) {
        var _context21, _context22;
        _forEachInstanceProperty__default["default"](_context21 = _sliceInstanceProperty__default["default"](_context22 = this.operands).call(_context22, 1)).call(_context21, function (operand, i) {
          if (!expressionValidator.ExpressionValidator.isString(operand.getType())) {
            var _context23;
            passSemanticCheck = false;
            semanticErrors.push(_concatInstanceProperty__default["default"](_context23 = "Expression".concat(i + 1, " should be String, not ")).call(_context23, operand.getType(), "."));
          }
        });
      } else {
        passSemanticCheck = false;
        semanticErrors.push("Expression cannot be ".concat(baseType.toString(), "."));
      }
      return {
        success: passSemanticCheck,
        errors: semanticErrors
      };
    }
  }]);
}(BaseCondition);

/**
 * Class for NOT condition.
 *
 * @export
 * @class NotCondition
 * @extends {BaseCondition}
 */
var NotCondition = /*#__PURE__*/function (_BaseCondition6) {
  function NotCondition(operands) {
    var _this5;
    _classCallCheck__default["default"](this, NotCondition);
    _this5 = _callSuper(this, NotCondition, [operands, operators_enum.PredicateOperator.Not]);
    _defineProperty__default["default"](_this5, "operandsTypes", [['NullCondition', operators_enum.RelationalOperator.Equal, operators_enum.RelationalOperator.Larger, operators_enum.RelationalOperator.LargerOrEqual, operators_enum.RelationalOperator.NotEqual, operators_enum.RelationalOperator.Smaller, operators_enum.RelationalOperator.SmallerOrEqual, operators_enum.PredicateOperator.BetweenAnd, operators_enum.PredicateOperator.In, operators_enum.PredicateOperator.IsEmpty, operators_enum.PredicateOperator.IsNumeric, operators_enum.PredicateOperator.Not, operators_enum.PredicateOperator.And, operators_enum.PredicateOperator.Or, 'Function']]);
    return _this5;
  }
  _inherits__default["default"](NotCondition, _BaseCondition6);
  return _createClass__default["default"](NotCondition, [{
    key: "toString",
    value: function toString() {
      return "(NOT ".concat(this.operands[0], ")");
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'NotCondition',
        operands: [this.operands[0].toJson()]
      };
    }

    // Here we assume that unsupported type of operands have been filter out in the component.
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      return {
        success: this.operands[0].semanticCheck().success,
        errors: []
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(nodeOrLink) {
      var operandEvalResult = this.operands[0].evaluate(nodeOrLink);
      if (!operandEvalResult.applicable) {
        return {
          applicable: false
        };
      }
      return {
        applicable: true,
        value: !operandEvalResult.value
      };
    }
  }]);
}(BaseCondition);

/**
 * Class for AND condition.
 *
 * @export
 * @class AndCondition
 * @extends {BaseCondition}
 */
var AndCondition = /*#__PURE__*/function (_BaseCondition7) {
  function AndCondition(operands) {
    var _this6;
    _classCallCheck__default["default"](this, AndCondition);
    _this6 = _callSuper(this, AndCondition, [operands, operators_enum.PredicateOperator.And]);
    _defineProperty__default["default"](_this6, "operandsTypes", [['NullCondition', operators_enum.RelationalOperator.Equal, operators_enum.RelationalOperator.Larger, operators_enum.RelationalOperator.LargerOrEqual, operators_enum.RelationalOperator.NotEqual, operators_enum.RelationalOperator.Smaller, operators_enum.RelationalOperator.SmallerOrEqual, operators_enum.PredicateOperator.BetweenAnd, operators_enum.PredicateOperator.In, operators_enum.PredicateOperator.IsEmpty, operators_enum.PredicateOperator.IsNumeric, operators_enum.PredicateOperator.Not, operators_enum.PredicateOperator.And, operators_enum.PredicateOperator.Or, 'Function'], ['NullCondition', operators_enum.RelationalOperator.Equal, operators_enum.RelationalOperator.Larger, operators_enum.RelationalOperator.LargerOrEqual, operators_enum.RelationalOperator.NotEqual, operators_enum.RelationalOperator.Smaller, operators_enum.RelationalOperator.SmallerOrEqual, operators_enum.PredicateOperator.BetweenAnd, operators_enum.PredicateOperator.In, operators_enum.PredicateOperator.IsEmpty, operators_enum.PredicateOperator.IsNumeric, operators_enum.PredicateOperator.Not, operators_enum.PredicateOperator.And, operators_enum.PredicateOperator.Or, 'Function']]);
    return _this6;
  }
  _inherits__default["default"](AndCondition, _BaseCondition7);
  return _createClass__default["default"](AndCondition, [{
    key: "toString",
    value: function toString() {
      var _context24;
      return _concatInstanceProperty__default["default"](_context24 = "(".concat(this.operands[0].toString(), " AND ")).call(_context24, this.operands[1].toString(), ")");
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'AndCondition',
        operands: [this.operands[0].toJson(), this.operands[1].toJson()]
      };
    }

    // Here we assume that unsupported type of operands have been filter out in the component.
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      return {
        success: this.operands[0].semanticCheck().success && this.operands[1].semanticCheck().success,
        errors: []
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(nodeOrLink) {
      var leftoperandEvalResult = this.operands[0].evaluate(nodeOrLink);
      var rightoperandEvalResult = this.operands[1].evaluate(nodeOrLink);
      if (!leftoperandEvalResult.applicable || !rightoperandEvalResult.applicable) {
        return {
          applicable: false
        };
      }
      return {
        applicable: true,
        value: leftoperandEvalResult.value && rightoperandEvalResult.value
      };
    }
  }]);
}(BaseCondition);
/**
 * Class for OR condition.
 *
 * @export
 * @class OrCondition
 * @extends {BaseCondition}
 */
var OrCondition = /*#__PURE__*/function (_BaseCondition8) {
  function OrCondition(operands) {
    var _this7;
    _classCallCheck__default["default"](this, OrCondition);
    _this7 = _callSuper(this, OrCondition, [operands, operators_enum.PredicateOperator.Or]);
    _defineProperty__default["default"](_this7, "operandsTypes", [['NullCondition', operators_enum.RelationalOperator.Equal, operators_enum.RelationalOperator.Larger, operators_enum.RelationalOperator.LargerOrEqual, operators_enum.RelationalOperator.NotEqual, operators_enum.RelationalOperator.Smaller, operators_enum.RelationalOperator.SmallerOrEqual, operators_enum.PredicateOperator.BetweenAnd, operators_enum.PredicateOperator.In, operators_enum.PredicateOperator.IsEmpty, operators_enum.PredicateOperator.IsNumeric, operators_enum.PredicateOperator.Not, operators_enum.PredicateOperator.And, operators_enum.PredicateOperator.Or, 'Function'], ['NullCondition', operators_enum.RelationalOperator.Equal, operators_enum.RelationalOperator.Larger, operators_enum.RelationalOperator.LargerOrEqual, operators_enum.RelationalOperator.NotEqual, operators_enum.RelationalOperator.Smaller, operators_enum.RelationalOperator.SmallerOrEqual, operators_enum.PredicateOperator.BetweenAnd, operators_enum.PredicateOperator.In, operators_enum.PredicateOperator.IsEmpty, operators_enum.PredicateOperator.IsNumeric, operators_enum.PredicateOperator.Not, operators_enum.PredicateOperator.And, operators_enum.PredicateOperator.Or, 'Function']]);
    return _this7;
  }
  _inherits__default["default"](OrCondition, _BaseCondition8);
  return _createClass__default["default"](OrCondition, [{
    key: "toString",
    value: function toString() {
      var _context25;
      return _concatInstanceProperty__default["default"](_context25 = "(".concat(this.operands[0].toString(), " OR ")).call(_context25, this.operands[1].toString(), ")");
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'OrCondition',
        operands: [this.operands[0].toJson(), this.operands[1].toJson()]
      };
    }

    // Here we assume that unsupported type of operands have been filter out in the component.
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      return {
        success: this.operands[0].semanticCheck().success && this.operands[1].semanticCheck().success,
        errors: []
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(nodeOrLink) {
      var leftoperandEvalResult = this.operands[0].evaluate(nodeOrLink);
      var rightoperandEvalResult = this.operands[1].evaluate(nodeOrLink);
      if (!leftoperandEvalResult.applicable || !rightoperandEvalResult.applicable) {
        return {
          applicable: false
        };
      }
      return {
        applicable: true,
        value: leftoperandEvalResult.value || rightoperandEvalResult.value
      };
    }
  }]);
}(BaseCondition);

exports.AndCondition = AndCondition;
exports.BaseCondition = BaseCondition;
exports.BetweenAndCondition = BetweenAndCondition;
exports.ComparisonCondition = ComparisonCondition;
exports.InCondition = InCondition;
exports.IsCondition = IsCondition;
exports.NotCondition = NotCondition;
exports.NullCondition = NullCondition;
exports.OrCondition = OrCondition;
